// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4172":"017e440e","6959":"ec961161","9782":"d46f857e"}[chunkId] + ".chunk.css";
};